import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Who,
  Benefits,
  Metrics,
  Values,
  Pricing,
  AreYouReady,
} from './components';

const LandingMediaKitEnSintoniaConTuSalud = ({ themeMode = 'light' }) => (
  <Box>
    <Container>
      <Who themeMode={themeMode} />
    </Container>
    <Container>
      <Benefits />
    </Container>
    <Container>
      <Metrics />
    </Container>
    <Container>
      <Values />
    </Container>
    <Container>
      <Pricing />
    </Container>
    <Container>
      <AreYouReady />
    </Container>
  </Box>
);

LandingMediaKitEnSintoniaConTuSalud.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default LandingMediaKitEnSintoniaConTuSalud;
